import { Component, OnInit } from '@angular/core';
import { ServiceResult } from '../available-services-layout/service-result.model';
import { Observable } from 'rxjs';
import { AvailableServicesService } from '../available-services-layout/available-services.service';

@Component({
  selector: 'app-highlighted-services',
  templateUrl: './highlighted-services.component.html',
  styleUrls: ['./highlighted-services.component.scss']
})
export class HighlightedServicesComponent implements OnInit {
  serviceResults$: Observable<Array<ServiceResult>>;
  constructor(private availableServices: AvailableServicesService) {}

  ngOnInit(): void {
    this.serviceResults$ = this.availableServices.getHighlightedServices();
  }
}
